import { gql } from '@/shared/graphql/generated/explorer';

export const getAuthorityTotalRewardsQuery = gql(/* GraphQL */ `
  query GetAuthorityTotalRewards {
    all: allAuthorityMemberships {
      aggregates {
        sum {
          reward
          rewardValueUsd
        }
      }
    }
  }
`);

export const GetDelegationRewardsSinceDaysAgoQuery = gql(/* GraphQL */ `
  query GetDelegationRewardsSinceDaysAgo($delegationIdSs58: String!, $startDate: Datetime!) {
    rewards: allDelegationActivities(
      filter: {
        accountByDelegatorAccountId: { idSs58: { equalTo: $delegationIdSs58 } }
        type: { equalTo: REWARD }
        eventByEventId: { blockByBlockId: { timestamp: { greaterThanOrEqualTo: $startDate } } }
      }
    ) {
      aggregates {
        sum {
          amount
          valueUsd
        }
      }
    }
  }
`);

// every FLIP the protocol has ever paid out for running the network, across all three payee
// tables — validators, the delegators backing them, and operator commission
export const getNetworkTotalEverRewardsQuery = gql(/* GraphQL */ `
  query GetNetworkTotalEverRewards {
    authority: allAuthorityMemberships {
      aggregates {
        sum {
          reward
          rewardValueUsd
        }
      }
    }
    delegator: allOperatorEpochDelegations {
      aggregates {
        sum {
          rewards
          rewardsValueUsd
        }
      }
    }
    operator: allOperatorEpoches {
      aggregates {
        sum {
          operatorRewardAmount
          operatorRewardValueUsd
        }
      }
    }
  }
`);
